// src/components/CreateCustomerModal.tsx

import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { CustomerFormData } from '../types';

interface CreateCustomerModalProps {
  show: boolean;
  onHide: () => void;
  formData: CustomerFormData;
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const CreateCustomerModal: React.FC<CreateCustomerModalProps> = ({
  show,
  onHide,
  formData,
  handleFormChange,
  handleSubmit
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Plesk Customer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="customerCompany">
            <Form.Label>Company</Form.Label>
            <Form.Control
              type="text"
              name="company"
              required
              value={formData.company}
              onChange={handleFormChange}
            />
          </Form.Group>
          <Form.Group controlId="customerName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleFormChange}
            />
          </Form.Group>
          <Form.Group controlId="customerLogin">
            <Form.Label>Login</Form.Label>
            <Form.Control
              type="text"
              name="login"
              required
              value={formData.login}
              onChange={handleFormChange}
            />
          </Form.Group>
          <Form.Group controlId="customerEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleFormChange}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Create Customer
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateCustomerModal;
